import { render } from "./auth-signup.vue?vue&type=template&id=03acde78&scoped=true&ts=true"
import script from "./auth-signup.vue?vue&type=script&lang=ts"
export * from "./auth-signup.vue?vue&type=script&lang=ts"

import "./auth-signup.vue?vue&type=style&index=0&id=03acde78&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03acde78"]])

export default __exports__